import React from "react";
import SideMenu from "./SideMenu";

const AdminLayout = ({ children }) => {
    const menuItems = [
        {
            name: "Dashboard",
            "url": "/admin/dashboard",
            icon: "fa-solid fa-gauge",
        },
        {
            name: "New Product",
            "url": "/admin/product/new",
            icon: "fa-solid fa-plus",
        },
        {
            name: "Products",
            "url": "/admin/products",
            icon: "fa-solid fa-box",
        },
        {
            name: "Orders",
            "url": "/admin/orders",
            icon: "fa-solid fa-receipt",
        },
        {
            name: "Users",
            "url": "/admin/users",
            icon: "fa-solid fa-user",
        },
        {
            name: "Reviews",
            "url": "/admin/reviews",
            icon: "fa-solid fa-star",
        },
    ];

    return (
        <div className="user-layout  " >
            {/* Header */}
            <div className=" mb-5 py-1 text-center ">
                <h2 className="fw-bold heading">Admin Dashboard 🧚🏻‍♀️</h2>
                <p className="text" style={{ color: "#e04f6e" }}>
                    Manage your profile, orders & preferences with ease.
                </p>
            </div>

            {/* Content */}
            <div className="container p-0">
                <div className="row justify-content-around">
                    {/* Sidebar */}
                    <div className="col-12 col-lg-3 mb-5">
                        <div className="card shadow-sm border-0 p-4 rounded-4" style={{
                            maxHeight: "300px",
                            position: "sticky",
                        }}>
                            <SideMenu menuItems={menuItems} />
                        </div>
                    </div>

                    {/* Dashboard Content */}
                    <div className="col-12 col-lg-8">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;

